// ABOUTME: Confirmation dialog for destructive actions, matching the design system.
// ABOUTME: Extracted from UserMenu so Settings can reuse it.

import React from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmLabel: string;
  variant?: "danger" | "warning";
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel,
  variant = "danger",
}) => {
  const color = variant === "danger" ? "var(--color-danger)" : "var(--color-warning)";

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div
        className="fixed inset-0 bg-black/30 animate-[fadeIn_150ms_ease-out]"
        aria-hidden="true"
      />
      <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4">
        <DialogPanel className="w-full sm:max-w-md bg-[var(--color-bg-secondary)] rounded-t-xl sm:rounded-[var(--radius-lg)] border border-[var(--color-border)] shadow-lg animate-[fadeIn_150ms_ease-out]">
          <div className="px-5 pt-5 pb-4">
            <div className="flex items-start gap-4">
              <div
                className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
                style={{ backgroundColor: `color-mix(in srgb, ${color} 10%, transparent)` }}
              >
                <ExclamationTriangleIcon className="h-5 w-5" style={{ color }} />
              </div>
              <div>
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold text-[var(--color-text-primary)]"
                >
                  {title}
                </DialogTitle>
                <p className="mt-1.5 text-sm text-[var(--color-text-tertiary)]">{description}</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 px-5 py-4 border-t border-[var(--color-border)]">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium rounded-md
                         border border-[var(--color-border)] bg-[var(--color-bg-secondary)]
                         text-[var(--color-text-primary)]
                         hover:bg-[var(--color-bg-hover)] transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="px-4 py-2 text-sm font-medium rounded-md text-[var(--color-text-inverse)] hover:opacity-90 transition-colors"
              style={{ backgroundColor: color }}
            >
              {confirmLabel}
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
